import { createAsyncThunk } from '@reduxjs/toolkit';
import { RpcClient } from '../rpc-socket/rpcClient';

export namespace AuthApi {
  export type TLogoutRequest = {
    token: string;
  };
  export type TLogoutResponse = boolean;

  export const logout = async () => {
    const token = localStorage.getItem('authToken');
    if (token) {
      const response = (await RpcClient.call('logout', {
        token,
      })) as Promise<TLogoutResponse>;
      return response;
    }
  };

  export type TConfirmActionEnum = 'rebot' | 'behaviour_change';
  export type TConfirmUserAccessRequest = {
    username: string;
    password: string;
    cancel: 'true' | 'false';
    action: TConfirmActionEnum;
  };

  export type TConfirmUserAccessResponse = {
    confirmed: boolean;
  };
  export const confirmUserAccess = (request: TConfirmUserAccessRequest) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      return RpcClient.call(
        'confirmUserAccess',
        request
      ) as Promise<TConfirmUserAccessResponse>;
    }
  };
}
